"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Methods = exports.GetTestIds = void 0;
var QuizMethods = _interopRequireWildcard(require("./QuizResult"));
var _ContentContainer = _interopRequireDefault(require("../ContentContainer/ContentContainer"));
var _ImportedContentFragment = _interopRequireDefault(require("../ContentFragments/ImportedContentFragment"));
var _Person = _interopRequireDefault(require("@mui/icons-material/Person"));
var _Print = _interopRequireDefault(require("@mui/icons-material/Print"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _QuizProvider = require("./QuizProvider");
var _classnames = _interopRequireDefault(require("classnames"));
var _function = require("../../utils/type-checks/function");
var _object = require("../../utils/type-checks/object");
var _string = require("../../utils/type-checks/string");
var _scroll = require("../../utils/scroll");
var _styles = require("@mui/material/styles");
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
Promise.resolve().then(() => _interopRequireWildcard(require("../../scss/partials/_quiz-print.scss")));
const merge = require("deepmerge"),
  GetTestIds = testId => {
    return {
      actions: (0, _string.isStringOfLength)(testId) ? `${testId}__actions` : undefined,
      component: (0, _string.isStringOfLength)(testId) ? testId : undefined,
      contentTitle: (0, _string.isStringOfLength)(testId) ? `${testId}__content-title` : undefined,
      controls: (0, _string.isStringOfLength)(testId) ? `${testId}__controls` : undefined,
      print: (0, _string.isStringOfLength)(testId) ? `${testId}__print` : undefined,
      title: (0, _string.isStringOfLength)(testId) ? `${testId}__title` : undefined,
      titleText: (0, _string.isStringOfLength)(testId) ? `${testId}__title-text` : undefined,
      firstName: (0, _string.isStringOfLength)(testId) ? `${testId}__user-name` : undefined
    };
  },
  Methods = exports.Methods = {
    GetTestIds: GetTestIds
  };

/**
 * Quiz Results Component
 *
 * @visibleName Quiz Result
 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
*/
exports.GetTestIds = GetTestIds;
const QuizResult = props => {
  const {
      altText = "Congratulations Trophy Icon",
      buttonText = "Take Quiz Again",
      buttonVariant = "primary",
      children,
      className,
      contentTitle = "Congratulations!",
      contentTitleIcon = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iODVweCIgaGVpZ2h0PSIxMjJweCIgdmlld0JveD0iMCAwIDg1IDEyMiIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KICAgIDx0aXRsZT5Hcm91cCAyOTwvdGl0bGU+CiAgICA8ZyBpZD0iUSZhbXA7QSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IlN0dWRlbnQtTG9hbi1SZXN1bHRzLVBhZ2UiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC03NzcsIC0zMzcpIj4KICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTI5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3NzcsIDMzNykiPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTIzLjg2NTkwMjIsNjYgQzIyLjc5NTIxNDQsNjYgMjEuNjc2OTg2NCw2NS44OTI3NjQ3IDIwLjUyMDUxOTYsNjUuNjc0Mzk0NiBDMTYuMDA4MzM1Miw2NC44MjMzMzYgMTEuNDMwMDA4LDYyLjM3OTM0NTQgNy42Mjc4MjYwOSw1OC43OTE4MzYzIEMxLjIwNDczMjcxLDUyLjczNDAxNTIgLTEuNTY4MTAwNjgsNDQuNTgxMjA1NyAwLjg4NTM4NjYzMywzOC45Njc5MjM4IEwyLjc5NTI2MjE5LDM5LjcxMDc3MjEgQzAuNjUyODUzMDg0LDQ0LjYxNjMwMDkgMy4yMzk2NTk2NCw1MS44OTY2MDQ3IDkuMDg5MTcwMjYsNTcuNDEzMzc0OSBDMTIuNjA2MTExLDYwLjczMTgyMDggMTYuODA5Mjg0MSw2Mi45ODU3MTI0IDIwLjkyNTY0NDcsNjMuNzYyNjgxMSBDMjQuODg4MDE2NCw2NC41MDc0NzkyIDI4LjI3NjgwNTMsNjMuNzg1MTAzMSAzMC40NjQ2ODc2LDYxLjcyMTMxMDQgQzMyLjY1MTUzNjUsNTkuNjU3NTE3OCAzMy40MjA0NDc0LDU2LjQ2Mjg3OTkgMzIuNjI3NzY2NCw1Mi43MjQyNjY1IEMzMS44MDUxMTQzLDQ4Ljg0MTM3MjggMjkuNDE0NjY5NCw0NC44NzY1OTAzIDI1Ljg5NjY5NTIsNDEuNTU5MTE5MiBDMTguNzQzOTYzMiwzNC44MTIwNjc0IDkuMTU2MzQ2NjIsMzIuODc4OTA2OSA0LjUyMTE3Nzg2LDM3LjI1MDIwODggTDMuMDU5ODMzNjksMzUuODcxNzQ3NCBDOC41MDAwODUyNywzMC43NDAwNDk2IDE5LjM5OTE5MTEsMzIuNjcyMjM1MiAyNy4zNTgwMzk0LDQwLjE4MDY1NzggQzMxLjE2MTI1NDgsNDMuNzY3MTkyMSAzMy43NTIxOTUzLDQ4LjA4NTg1MTIgMzQuNjU0NDI1NCw1Mi4zNDExNDM5IEMzNS41ODY2MjY2LDU2Ljc0MDcxNjkgMzQuNjE4MjUzNSw2MC41NjEyMTkyIDMxLjkyNjAzMTgsNjMuMDk5NzcxOCBDMjkuOTAxNDM5Nyw2NS4wMDk1MzU1IDI3LjEwODk3MDEsNjYgMjMuODY1OTAyMiw2NiIgaWQ9IkZpbGwtMSIgZmlsbD0iIzAwNDU2OSI+PC9wYXRoPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTEwLjgxNjEzMDUsMzcuOTMyNTkxMiBDOS43Mjk0NTM4NCwzNy45MzI1OTEyIDguMjIzMTk5MjUsMzguMTM2NDc5NiA3LjIxMzk5ODYxLDM5LjEwNTY3NDEgQzYuMDM5Nzg0MTEsNDAuMjMzMzQxMSA1LjcwMjcxMzExLDQyLjQxODEzNTQgNi4zMTM0NjU2NCw0NC45NTA3OTYyIEM3LjAzMDg3MzQ3LDQ3LjkyMjE1NTIgOC45Mjk1MzkwNyw1MS4wMDE3MzkzIDExLjY2MDMxNzMsNTMuNjI0MjY1NiBDMTUuMTU1NzkzOSw1Ni45ODIxNDI5IDE5LjU2ODkwODUsNTkuMDY3NDA4OCAyMy4xNzcwNzc1LDU5LjA2NzQwODggQzI0LjI2Mzc1NDEsNTkuMDY3NDA4OCAyNS43NzEwMTQ5LDU4Ljg2NDQ4NjcgMjYuNzc5MjA5NCw1Ny44OTUyOTIyIEMyOS4wMDc5MDI3LDU1Ljc1NDk0NzQgMjguMzk0MTMxNiw0OS4xOTU3MzI4IDIyLjMzMjg5MDcsNDMuMzc1NzM0NCBDMTguODM3NDE0MSw0MC4wMTc4NTcxIDE0LjQyNDI5OTUsMzcuOTMyNTkxMiAxMC44MTYxMzA1LDM3LjkzMjU5MTIgTTIzLjE3ODA4MzcsNjEgTDIzLjE3NzA3NzUsNjEgQzE5LjA1NDc0OTUsNjEgMTQuMDk3MjkwMyw1OC42OTczMTc2IDEwLjIzNzU3NTgsNTQuOTkwNjA3NiBDNy4yNDQxODQwNyw1Mi4xMTY4NDQ1IDUuMTU0MzQzODcsNDguNzA0ODU0NyA0LjM1MzQyMjkyLDQ1LjM4NjU5NTUgQzMuNTczNjMxOCw0Mi4xNTI0MDQxIDQuMDk3ODUyNjcsMzkuMzY0NjQxMyA1Ljc5MTI1NzEzLDM3LjczOTMzMjEgQzcuMjg3NDQ5OSwzNi4zMDE0ODQyIDkuMzQ5MTE3MDEsMzYgMTAuODE2MTMwNSwzNiBDMTQuOTM4NDU4NSwzNiAxOS44OTU5MTc3LDM4LjMwMjY4MjQgMjMuNzU1NjMyMiw0Mi4wMDkzOTI0IEMzMC40NTg4MTczLDQ4LjQ0Njg1MzcgMzEuNDY2MDA1Niw1Ni4xMjY5NzEyIDI4LjIwMTk1MDksNTkuMjYxNjM0MiBDMjYuNzA1NzU4MSw2MC42OTg1MTU4IDI0LjY0NTA5NzIsNjEgMjMuMTc4MDgzNyw2MSIgaWQ9IkZpbGwtMyIgZmlsbD0iIzAwNDU2OSI+PC9wYXRoPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTczLjg4MDg1NjYsMzQuOTUxMzQ1MyBDNzIuOTQ4MjM2OCwzNC45NTEzNDUzIDcxLjk2ODA1NTQsMzUuMDQ1OTA3OCA3MC45NDk2MTgsMzUuMjM3OTU3MyBDNjYuODMxNDA4OSwzNi4wMTQ5MjkyIDYyLjYyNjM0ODIsMzguMjY5ODA1IDU5LjEwNjc5NDEsNDEuNTg3Mjg5NyBDNTUuNTg4MjczOSw0NC45MDQ3NzQ1IDUzLjE5Njc1NTUsNDguODcwNTQ4MiA1Mi4zNzM3MzQxLDUyLjc1MjQ4MyBDNTEuNTgwNjk3MSw1Ni40OTExMTE5IDUyLjM0ODkxOTQsNTkuNjg2NzM3OCA1NC41Mzc3ODQyLDYxLjc1MDUzODkgQzU5LjE3NDAwMDYsNjYuMTIxODU4OCA2OC43Njc5OTA4LDY0LjE4OTY2NTIgNzUuOTIyOTAxLDU3LjQ0MjU4NTYgQzgzLjA3ODg0NTIsNTAuNjk1NTA2IDg1LjEyODEyNzMsNDEuNjUwNjU2MyA4MC40OTI5NDQ4LDM3LjI3OTMzNjQgQzc4Ljg2NjU0NjksMzUuNzQ1ODY0OSA3Ni41NzYzNTUzLDM0Ljk1MTM0NTMgNzMuODgwODU2NiwzNC45NTEzNDUzIE02MS4xNDI2MzQ5LDY2IEM1Ny45NzQ2MjI2LDY2IDU1LjEzNTQwNTMsNjUuMDY5OTczNCA1My4wNzU3ODM4LDYzLjEyOTAwNiBDNTAuMzgyMzUzLDYwLjU4OTQ2OCA0OS40MTI1MTExLDU2Ljc2ODk1IDUwLjM0NjE2NDksNTIuMzcwMzMzNyBDNTEuMjQ4ODAwMiw0OC4xMTQwNDg2IDUzLjg0MDkwNDIsNDMuNzk2MzQ2NiA1Ny42NDQ3OTM3LDQwLjIwODgyMjYgQzYxLjQ0OTcxNywzNi42MjEyOTg3IDY2LjAzMDEwMDMsMzQuMTc4MjcyOSA3MC41NDMyNzcsMzMuMzI2MjM2IEM3NS4yMTA1MTE4LDMyLjQ0NTkyNzggNzkuMjYxNTE0NSwzMy4zNjEzMzE0IDgxLjk1NDk0NTMsMzUuOTAwODY5MyBDODcuMzk2NjA2LDQxLjAzMTYxMzUgODUuMzQ3MzI0LDUxLjMxNDU0ODggNzcuMzg0OTAxNSw1OC44MjEwNTI3IEM3Mi40MzY0MzMyLDYzLjQ4Nzc1ODQgNjYuMzQ3NTIxOSw2NiA2MS4xNDI2MzQ5LDY2IiBpZD0iRmlsbC01IiBmaWxsPSIjMDA0NTY5Ij48L3BhdGg+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNNTUuODA4ODM1NSw1OS4yNzc0NTgxIEM1NC4zMTM1MzE1LDU3LjgzNzQ5MDUgNTQsNTUuODU1NTk5NSA1NCw1NC40NDU2MzEyIEM1NCw1MC40Nzk5MTM5IDU2LjM5NDY5NzIsNDUuNzEwOTg4OSA2MC4yNDk1MjY1LDQxLjk5ODgxNDMgQzYzLjIzOTEyOTYsMzkuMTE5ODQ2NyA2Ni43ODY0NTY5LDM3LjEwOTg5MTkgNzAuMjM4MzE3OSwzNi4zNDA1NTQ0IEM3My42MDE3NDcsMzUuNTg5NjAzNSA3Ni40OTk5MDM0LDM2LjA5Mzc4NTcgNzguMTkxMTY0NSwzNy43MjI0NTg4IEM3OS42ODY0Njg1LDM5LjE2MjQyNjQgODAsNDEuMTQ0MzE3NCA4MCw0Mi41NTUyNTM0IEM4MCw0NS41ODIyODIxIDc4LjU4OTEwODMsNDkuMTUwMjY2NCA3Ni4xMzAwOTcsNTIuMzQ1Njc4NCBMNzQuNTE2MjEzOCw1MS4xOTIxNTYgQzc2LjcyMjk5MzEsNDguMzIzODMzNCA3Ny45OTAxODI4LDQ1LjE3NTgzOTYgNzcuOTkwMTgyOCw0Mi41NTUyNTM0IEM3Ny45OTAxODI4LDQxLjUxMDExNTYgNzcuNzc4MTQ3MSw0MC4wNjE0Mzg1IDc2Ljc3MDIyMzgsMzkuMDkwODE1MSBDNzUuNTk3NDk1NSwzNy45NjE0ODU3IDczLjMyMzM4NzMsMzcuNjM5MjM0OSA3MC42OTI1MzY2LDM4LjIyNTY3MzMgQzY3LjYwMTQzNzgsMzguOTE1NjU3OCA2NC4zOTc3ODkyLDQwLjc0MDc3OCA2MS42NzA0NjczLDQzLjM2NzE3MDYgQzU4LjE3OTQxNDgsNDYuNzI5OTk4MiA1Ni4wMDk4MTcyLDUwLjk3NDQxODkgNTYuMDA5ODE3Miw1NC40NDQ2NjM1IEM1Ni4wMDk4MTcyLDU1LjQ4OTgwMTMgNTYuMjIxODUyOSw1Ni45Mzg0Nzg0IDU3LjIyOTc3NjIsNTcuOTA5MTAxNyBDNTguNDAyNTA0NSw1OS4wMzg0MzEyIDYwLjY3NzYxNzYsNTkuMzYxNjQ5NyA2My4zMDc0NjM0LDU4Ljc3NDI0MzYgQzY2LjM5ODU2MjIsNTguMDg0MjU5MSA2OS42MDIyMTA4LDU2LjI1OTEzODggNzIuMzI5NTMyNyw1My42MzI3NDYzIEw3My43NTA0NzM1LDU1LjAwMTEwMjYgQzcwLjc2MDg3MDQsNTcuODgwMDcwMSA2Ny4yMTM1NDMxLDU5Ljg5MDAyNSA2My43NjE2ODIxLDYwLjY1OTM2MjUgQzYyLjczOTY5LDYwLjg4Nzc0NDUgNjEuNzYwOTA5MSw2MSA2MC44NDU0MzczLDYxIEM1OC43NDgxOTMxLDYxIDU2Ljk4NTU4MzQsNjAuNDExNjI2MSA1NS44MDg4MzU1LDU5LjI3NzQ1ODEgWiIgaWQ9IkZpbGwtOCIgZmlsbD0iIzAwNDU2OSI+PC9wYXRoPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTYwLDExNyBMNTcuOTYwMjg1NiwxMTcgTDU3Ljk2MDI4NTYsMTExLjc4MjkyNyBDNTAuNjg5NzIzNCwxMTAuOTIyNTkyIDQ1LjEyMjMyMjksMTAwLjAyNzMwNyA0NS4xMjIzMjI5LDg2LjI3Mzc0MyBDNDUuMTIyMzIyOSw4Mi4zNDU2OTgzIDQ1LjYwMjY3NTYsNzguNDY1ODMyNCA0Ni41MTk1MjczLDc0Ljk2NjQ4MDQgTDM5LjM5MDcyNTMsNzQuOTY2NDgwNCBDNDAuMzA2NTU3MSw3OC40NjU4MzI0IDQwLjc4NzkyOTcsODIuMzQ1Njk4MyA0MC43ODc5Mjk3LDg2LjI3Mzc0MyBDNDAuNzg3OTI5Nyw5OS45NzEyNjI2IDM1LjI2NTQwMjgsMTEwLjgzMzExNyAyOC4wMzk3MTQ0LDExMS43NzIxMTIgTDI4LjAzOTcxNDQsMTE3IEwyNiwxMTcgTDI2LDEwOS44NzE1MDggTDI3LjAxOTg1NzIsMTA5Ljg3MTUwOCBDMzMuMzc3NjQ3MSwxMDkuODcxNTA4IDM4Ljc0ODIxNTIsOTkuMDY1Njk4MyAzOC43NDgyMTUyLDg2LjI3Mzc0MyBDMzguNzQ4MjE1Miw4Mi4wNTE3MDk1IDM4LjE3MDk3NjEsNzcuODk1NTUzMSAzNy4wNzg3MDksNzQuMjU2NTgxIEwzNi43MDEzNjE4LDczIEw0OS4yMDc4NzA5LDczIEw0OC44MzA1MjM3LDc0LjI1NjU4MSBDNDcuNzM5Mjc2NSw3Ny44OTU1NTMxIDQ3LjE2MjAzNzMsODIuMDUxNzA5NSA0Ny4xNjIwMzczLDg2LjI3Mzc0MyBDNDcuMTYyMDM3Myw5OS4wNjU2OTgzIDUyLjUzMjYwNTQsMTA5Ljg3MTUwOCA1OC44OTAzOTUzLDEwOS44NzE1MDggTDU5LjkxMDI1MjYsMTA5Ljg3MTUwOCBMNjAsMTEwLjg0OTgzMiBMNjAsMTE3IFoiIGlkPSJGaWxsLTEwIiBmaWxsPSIjMDA0NTY5Ij48L3BhdGg+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNNjcsMzEgQzY3LDYxLjM3NDY2NjcgNTUuODA3LDg2IDQyLDg2IEMyOC4xOTMsODYgMTcsNjEuMzc0NjY2NyAxNywzMSBMNjcsMzEgWiIgaWQ9IkZpbGwtMTIiIGZpbGw9IiNGRkRBNjciPjwvcGF0aD4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xOC4wNDI1Mzg1LDMxLjkyMjc0NjggQzE4LjI4MDAxOTIsNjAuNzY4NzU1NCAyOS4xNjAzMDc3LDg0LjA3NzI1MzIgNDIuNSw4NC4wNzcyNTMyIEM1NS44Mzk2OTIzLDg0LjA3NzI1MzIgNjYuNzE5OTgwOCw2MC43Njg3NTU0IDY2Ljk1NzQ2MTUsMzEuOTIyNzQ2OCBMMTguMDQyNTM4NSwzMS45MjI3NDY4IFogTTQyLjUsODYgQzI3Ljg4ODMwNzcsODYgMTYsNjEuMzA5MDQ3MiAxNiwzMC45NjEzNzM0IEwxNiwzMCBMNjksMzAgTDY5LDMwLjk2MTM3MzQgQzY5LDYxLjMwOTA0NzIgNTcuMTEyNzExNSw4NiA0Mi41LDg2IEw0Mi41LDg2IFoiIGlkPSJGaWxsLTE0IiBmaWxsPSIjMDA0NTY5Ij48L3BhdGg+CiAgICAgICAgICAgICAgICA8ZyBpZD0iR3JvdXAtMTgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzLCAxMTQpIiBmaWxsPSIjRjVBODFGIj4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTguMTQyNTQyOCwwIEw3LjA3OTQ3NjY0LDAgQzMuMTcwMzY1NTcsMCAwLDMuMjgzNjI4NzggMCw3LjMzNTc2NjQyIEwwLDggTDU5LDggTDU5LDcuMzM1NzY2NDIgQzU5LDMuMjgzNjI4NzggNTUuODI5NjM0NCwwIDUxLjkxOTUxNjksMCBMMjIuODYxODU4NCwwIiBpZD0iRmlsbC0xNiI+PC9wYXRoPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPHBvbHlnb24gaWQ9IkZpbGwtMTkiIGZpbGw9IiMwMDQ1NjkiIHBvaW50cz0iNDEgOCA0MyA4IDQzIDAgNDEgMCI+PC9wb2x5Z29uPgogICAgICAgICAgICAgICAgPHBvbHlnb24gaWQ9IkZpbGwtMjEiIGZpbGw9IiMwMDQ1NjkiIHBvaW50cz0iNDEgOCA0MyA4IDQzIDQgNDEgNCI+PC9wb2x5Z29uPgogICAgICAgICAgICAgICAgPHBvbHlnb24gaWQ9IkZpbGwtMjIiIGZpbGw9IiMwMDQ1NjkiIHBvaW50cz0iMjkuMTM1NjI5NyAxMSAyNyA3LjkwMTUxMDAzIDI4Ljg2NTQ0NjcgNyAzMSAxMC4wOTg0OSI+PC9wb2x5Z29uPgogICAgICAgICAgICAgICAgPHBvbHlnb24gaWQ9IkZpbGwtMjMiIGZpbGw9IiMwMDQ1NjkiIHBvaW50cz0iMjAuOTgzODY4OSAxOSAxNCAxNS41MTkyOTgyIDE1LjAxNjEzMTEgMTQgMjIgMTcuNDgwNzAxOCI+PC9wb2x5Z29uPgogICAgICAgICAgICAgICAgPHBvbHlnb24gaWQ9IkZpbGwtMjUiIGZpbGw9IiMwMDQ1NjkiIHBvaW50cz0iNjQuMDE2MTMxMSAxOSA2MyAxNy40ODA3MDE4IDY5Ljk4Mzg2ODkgMTQgNzEgMTUuNTE5Mjk4MiI+PC9wb2x5Z29uPgogICAgICAgICAgICAgICAgPHBvbHlnb24gaWQ9IkZpbGwtMjciIGZpbGw9IiMwMDQ1NjkiIHBvaW50cz0iNTQuODY0MzcwMyAxMSA1MyAxMC4wOTg0OSA1NS4xMzQ1NTMzIDcgNTcgNy45MDE1MTAwMyI+PC9wb2x5Z29uPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=",
      contentTitleTag = "h2",
      customActions,
      customTheme = {},
      fragmentId,
      hideActions = false,
      hideButton = false,
      hideContentTitle = false,
      hideContentIcon = false,
      hideControls = false,
      hidePrint = false,
      hideUsername = false,
      onClick,
      printButtonIcon = /*#__PURE__*/_react.default.createElement(_Print.default, null),
      quizCompleteName,
      styles = {},
      title,
      titleTag = "h1",
      testId,
      userTitleIcon = /*#__PURE__*/_react.default.createElement(_Person.default, null)
    } = props,
    componentRef = (0, _react.useRef)(null),
    quizTheme = _QuizProvider.Methods.useCustomTheme(),
    theme = merge.all([(0, _styles.useTheme)(), quizTheme, customTheme]),
    state = _QuizProvider.Methods.useState(),
    customClassNames = (0, _classnames.default)({
      "quiz__result": true,
      [`${className}`]: className
    }),
    customStyles = merge({
      textAlign: "center",
      ".quiz__result-title-block": {
        alignItems: "flex-end",
        borderColor: theme.quiz.results.title.borderColor,
        borderStyle: "solid",
        borderWidth: "0 0 0.1rem",
        display: {
          xs: "block",
          md: "flex"
        },
        justifyContent: "space-between",
        width: "100%"
      },
      ".quiz__result-title-controls": {
        alignItems: "center",
        backgroundColor: theme.quiz.results.title.backgroundColor,
        borderRadius: "0.8rem",
        borderBottomLeftRadius: "0",
        borderBottomRightRadius: "0",
        padding: "0 2.8rem",
        display: "flex",
        justifyContent: "center",
        ".quiz__result-title-print": {
          alignItems: "center",
          background: theme.quiz.results.title.printText.background,
          border: "none",
          color: theme.quiz.results.title.printText.color,
          cursor: "pointer",
          display: "flex",
          fontFamily: theme.quiz.results.title.printText.fontFamily,
          fontSize: "inherit",
          fontWeight: "normal",
          lineHeight: "1.4",
          outline: "inherit",
          padding: "1.4rem 0",
          textAlign: "left",
          textDecoration: "none",
          textTransform: "none",
          "@media(hover: hover)": {
            "&:hover": {
              textDecoration: "underline"
            }
          },
          ".MuiButton-startIcon": {
            color: theme.quiz.results.title.printIcon.color,
            margin: "0",
            marginRight: "1rem",
            height: "2.8rem",
            padding: "0",
            width: "2.8rem",
            ">*": {
              height: "100%",
              width: "100%"
            }
          }
        },
        ".quiz__result-title-user": {
          alignItems: "center",
          borderRightColor: theme.quiz.results.title.user.borderRight.color,
          borderRightStyle: "solid",
          borderRightWidth: "0.1rem",
          display: "flex",
          marginRight: "1.8rem",
          paddingRight: "1.8rem",
          ".quiz__result-title-user-icon": {
            alignItems: "center",
            backgroundColor: theme.quiz.results.title.user.icon.backgroundColor,
            borderRadius: "50%",
            color: theme.quiz.results.title.user.icon.color,
            display: "inline-flex",
            height: "2.8rem",
            justifyContent: "center",
            width: "2.8rem",
            ">*": {
              height: "80%",
              width: "80%"
            }
          },
          ".quiz__result-title-user-text": {
            fontFamliy: theme.quiz.results.title.user.text.fontFamily,
            fontWeight: "normal",
            lineHeight: "1.4",
            paddingLeft: "1em",
            textAlign: "left"
          }
        }
      },
      ".quiz__result-content": {
        display: "flex",
        flexDirection: "column",
        rowGap: "2rem"
      },
      ".quiz__result-content-icon": {
        marginTop: "2rem"
      },
      ".quiz__result-actions": {
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        marginTop: "5rem"
      },
      ".quiz__result-button": {
        marginLeft: "0",
        textAlign: "center"
      }
    }, styles),
    testIdObject = QuizMethods.Methods.GetTestIds(testId);
  (0, _react.useEffect)(() => {
    (0, _scroll.scrollToElement)(componentRef.current);
  }, [componentRef]);
  (0, _react.useEffect)(() => {
    if ((0, _string.isStringOfLength)(quizCompleteName)) {
      _QuizProvider.Methods.sendAnalytics(quizCompleteName, "quizComplete");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_react.default.createElement(_ContentContainer.default, {
    className: customClassNames,
    customTheme: theme,
    styles: customStyles,
    testId: testIdObject.component
  }, /*#__PURE__*/_react.default.createElement("div", {
    ref: componentRef
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: customClassNames,
    "data-testid": testIdObject.title,
    sx: customStyles
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "quiz__result-title-block"
  }, (0, _string.isStringOfLength)(title) && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "quiz__result-title heading--isInteriorPageSubHeading",
    component: titleTag,
    "data-testid": testIdObject.titleText
  }, title), title && !(0, _string.isStringOfLength)(title) && /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "quiz__result-title",
    component: "div",
    "data-testid": testIdObject.titleText
  }, title), !hideControls && /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "quiz__result-title-controls",
    "data-testid": testIdObject.controls
  }, !hideUsername && (0, _object.isObject)(state.formState) && (0, _string.isStringOfLength)(state.formState.firstName) && /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "quiz__result-title-user",
    "data-testid": testIdObject.firstName
  }, (0, _string.isStringOfLength)(userTitleIcon) && /*#__PURE__*/_react.default.createElement("img", {
    alt: `icon for ${state.formState.firstName}`,
    className: "quiz__result-title-user-icon",
    src: userTitleIcon
  }), userTitleIcon && !(0, _string.isStringOfLength)(userTitleIcon) && /*#__PURE__*/_react.default.createElement(_material.Box, {
    component: "span",
    className: "quiz__result-title-user-icon"
  }, userTitleIcon), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "quiz__result-title-user-text",
    component: "span"
  }, state.formState.firstName)), !hidePrint && (0, _string.isStringOfLength)(printButtonIcon) && /*#__PURE__*/_react.default.createElement(_material.Button, {
    className: "quiz__result-title-print",
    "data-testid": testIdObject.print,
    onClick: () => window.print(),
    startIcon: /*#__PURE__*/_react.default.createElement("img", {
      src: printButtonIcon,
      alt: "icon for print button"
    }),
    variant: "text"
  }, "Print Results"), !hidePrint && printButtonIcon && !(0, _string.isStringOfLength)(printButtonIcon) && /*#__PURE__*/_react.default.createElement(_material.Button, {
    className: "quiz__result-title-print",
    "data-testid": testIdObject.print,
    onClick: () => window.print(),
    startIcon: printButtonIcon,
    variant: "text"
  }, "Print Results")))), /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "quiz__result-content"
  }, !hideContentTitle && /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "quiz__result-content-header-block"
  }, !hideContentIcon && (0, _string.isStringOfLength)(contentTitleIcon) && /*#__PURE__*/_react.default.createElement("img", {
    alt: altText,
    className: "quiz__result-content-icon",
    src: contentTitleIcon
  }), !hideContentIcon && contentTitleIcon && !(0, _string.isStringOfLength)(contentTitleIcon) && /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "quiz__result-content-icon"
  }, contentTitleIcon), (0, _string.isStringOfLength)(contentTitle) && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "quiz__result-content-header heading--isInteriorPageSubHeading",
    component: contentTitleTag,
    "data-testid": testIdObject.contentTitle
  }, contentTitle), contentTitle && !(0, _string.isStringOfLength)(contentTitle) && /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "quiz__result-content-header",
    component: "div",
    "data-testid": testIdObject.contentTitle
  }, contentTitle)), fragmentId && /*#__PURE__*/_react.default.createElement(_ImportedContentFragment.default, {
    fragmentId: fragmentId
  }), children), !hideActions && /*#__PURE__*/_react.default.createElement(_material.Box, {
    component: "div",
    className: "quiz__result-actions",
    "data-testid": testIdObject.actions
  }, !hideButton && (0, _function.isFunction)(onClick) && /*#__PURE__*/_react.default.createElement(_material.Button, {
    className: "quiz__result-button",
    onClick: onClick,
    type: "button",
    variant: buttonVariant
  }, buttonText), customActions)));
};

// Define propTypes;
QuizResult.propTypes = {
  /** Alt Text for content title icon (Default Value: "Congratulations Trophy Icon") */
  altText: _propTypes.default.string,
  /** Text for Reset Quiz Button (Default Value: "Take Quiz Again") */
  buttonText: _propTypes.default.string,
  /** Button Variant (Default Value: "primary") */
  buttonVariant: _propTypes.default.string,
  /** Child Nodes, before after content fragment */
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
  /** Custom Class Name(s) */
  className: _propTypes.default.string,
  /** Content title string / custom component (Default Value: "Congratulations!") */
  contentTitle: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  /** String or component for content title icon (Default Value: Base 64 Image) */
  contentTitleIcon: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  /** HTML Tag for content title component (Default Value: "h2") */
  contentTitleTag: _propTypes.default.string,
  /** Custom Actions component */
  customActions: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
  /** Custom theme object (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /** Fragment Id for content in main component */
  fragmentId: _propTypes.default.string,
  /** Boolean to hide actions section (Default Value: false) */
  hideAction: _propTypes.default.bool,
  /** Boolean to hide default action button (Default Value: false) */
  hideButton: _propTypes.default.bool,
  /** Boolean to hide content title block (Default Value: false) */
  hideContentTitle: _propTypes.default.bool,
  /** Boolean to hide icon at top of content section (Default Value: false) */
  hideContentIcon: _propTypes.default.bool,
  /** Boolean to hide controls (Default Value: false) */
  hideControls: _propTypes.default.bool,
  /** Boolean to hide print button (Default Value: false) */
  hidePrint: _propTypes.default.bool,
  /** Boolean to hide firstName display (Default Value: false) */
  hideUsername: _propTypes.default.bool,
  /** onClick method for Reset Button */
  onClick: _propTypes.default.func,
  /** String or component for user icon (Default Value: <PrintIcon />) */
  printButtonIcon: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  /** Quiz Name to record in quizCompletion analytic event */
  quizCompleteName: _propTypes.default.string,
  /** Custom Styles object (Default Value: {}) */
  styles: _propTypes.default.object,
  /** @ignore */
  testId: _propTypes.default.string,
  /** Results title string or custom component */
  title: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  /** HTML Tag for page title component (Default Value: "h1") */
  titleTag: _propTypes.default.string,
  /** String or component for user icon (Default Value: <PersonIcon />) */
  userTitleIcon: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string])
};

// Export component as default;
var _default = exports.default = QuizResult;